export enum ActionKeyHome {
  post = "post",
  follow = "follow",
  information = 'information',
  category = 'category'
}

